import { atom } from 'jotai';
import { FeedCategory } from 'shared/models/feed';

export const $CategoryList = atom<Promise<FeedCategory[]>>(new Promise<never>(() => void 0));
$CategoryList.debugLabel = '$CategoryList';
